import { Frame } from '../Frame';

type EmbedProps = {
  attrs: {
    href: string;
  };
};

export const Vimeo = (props: EmbedProps): string | null => {
  // Extract matches directly within the component
  const extractMatches = (href: string): RegExpMatchArray | null => {
    const regex =
      /(http|https)?:\/\/(www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)?(\d+)(?:\/|\?)?([\d\w]+)?/;

    return href.match(regex);
  };

  // Extract the matches from the URL
  const matches = extractMatches(props.attrs.href);
  if (!matches) return null; // If no match is found, return null

  const videoId = matches[4];
  const hId = matches[5];

  // Construct the Vimeo embed URL
  const embedUrl = `https://player.vimeo.com/video/${videoId}?byline=0${
    hId ? `&h=${hId}` : ''
  }`;

  return Frame({
    src: embedUrl,
    title: `Vimeo Embed (${videoId})`,
    height: '412px',
    border: false,
  });
};

// Add the isMatch function for Vimeo
Vimeo.isMatch = (href: string): boolean => {
  const regex =
    /^(https?):\/\/(www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)?(\d+)(\/)?(?:\?.*|#.*)?$/i;

  return regex.test(href);
};
